/**
 * @generated SignedSource<<04108713ad056ce772b7c8950a684cfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_item" | "CheckoutPaymentStep_item" | "CheckoutProgressReview_item" | "CheckoutReviewStep_item">;
  readonly " $fragmentType": "CheckoutSteps_item";
};
export type CheckoutSteps_item$key = {
  readonly " $data"?: CheckoutSteps_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutProgressReview_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStep_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "853ad2dcdb18d8ed2ba789ee5aa096bd";

export default node;
